import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  useHistory,
  useLocation,
} from 'react-router-dom';
import { Container } from 'reactstrap';
import { hot } from 'react-hot-loader';
import {
  ToastContainer,
  NotFound,
  SessionProvider,
  RouteWithSubRoutes,
  useSession,
} from '@cordata/buffet';
import Helmet from 'react-helmet';
import { toast } from 'react-toastify';

import { Navbar } from '~/components';
import { routes } from '~/utils';

const Paths = () => {
  const { isAuthed } = useSession();

  if (window.location.pathname === '/' && isAuthed) return (<Redirect to="/home" />);
  if (window.location.pathname === '/' && !isAuthed) return (<Redirect to="/login" />);

  return (
    <>
      <Helmet
        titleTemplate="%s - Cordata"
      />

      <Route
        path="/"
        render={props => (
          <Navbar {...props} routes={routes.filter(r => r.main)} />
      )}
      />

      <Container fluid className="my-3">
        <Switch>
          {routes.map(r => (
            <RouteWithSubRoutes key={r.path} {...r} />
        ))}

          <Route render={props => <NotFound {...props} isRoute />} />
        </Switch>
      </Container>
    </>
  );
};

const ContextProviderWrapper = () => {
  const location = useLocation();
  const history = useHistory();

  const userInPrivateRoutes = () =>
    location.pathname !== '/' &&
      !location.pathname.includes('forgot-password') &&
      !location.pathname.includes('login') &&
      !location.pathname.includes('logout') &&
      !location.pathname.includes('activations');

  useEffect(() => {
    const routeAttempted = localStorage.getItem('route-attempted');
    const ra = JSON.parse(routeAttempted);

    if (routeAttempted && location.pathname !== ra.pathname && userInPrivateRoutes()) {
      toast.info('Redirecting to previous page ...');

      localStorage.removeItem('route-attempted');

      history.replace(ra.pathname, ra.state);
    }
  }, []);

  return (
    <SessionProvider userInPrivateRoutes={userInPrivateRoutes}>
      <Paths />
    </SessionProvider>
  );
};

const App = () => (
  <Router
    getUserConfirmation={(message, callback) => {
      const allowTransition = window.confirm(message);

      callback(allowTransition);
    }}
  >
    <ContextProviderWrapper />

    <ToastContainer
      position="bottom-center"
      autoClose={2500}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  </Router>
);

export default hot(module)(App);
